import { useState } from "react";
import useHttp from "./use_http";
import { message } from "antd";
import FormatHelper from "../helper/format_helper";

const useOrder = () => {
  const { HttpService } = useHttp();

  const [getProvincesLoading, setGetProvincesLoading] = useState(false);
  const [getCitiesLoading, setGetCitiesLoading] = useState(false);
  const [getDevicesLoading, setGetDevicesLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [confirmMobileLoading, setConfirmMobileLoading] = useState(false);
  const [verifyMobileLoading, setVerifyMobileLoading] = useState(false);

  const [submitModal, setSubmitModal] = useState(false);
  const [now, setNow] = useState(null);
  const [showReset, setShowReset] = useState(true);

  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [devices, setDevices] = useState([]);

  const [query, setQuery] = useState(null);

  const [formData, setFormData] = useState({
    mobile: "",
    province_id: null,
    city: null,
    device_id: null,
    order_token: "",
    order_form_token: "",
    utm_campaign: "",
    keyword: "",
    utm_adgroup: "",
    gclid: "",
    kwd_id: "",
  });

  const getProvinces = async () => {
    let array = [];
    setGetProvincesLoading(true);
    try {
      const response = await HttpService.get("/locations");
      setGetProvincesLoading(false);
      response.data.data.map((prov) => {
        if (prov.enabled === 1) {
          array.push({
            label: prov.title,
            value: prov.id,
          });
        }
      });
      setProvinces(array);
      if (query.province_id) {
        if (!array.find((item) => item.value == query.province_id)) {
          setFormData({ ...formData, province_id: 92 });
        }
      }
    } catch ({ err, response }) {
      setGetProvincesLoading(false);
    }
  };

  const getCities = async (id) => {
    let array = [];
    try {
      setGetCitiesLoading(true);
      const response = await HttpService.get(
        `/locations?status=1&parent_id=${id}`
      );
      setGetCitiesLoading(false);
      response.data.data.map((prov) => {
        if (prov.enabled === 1) {
          array.push({
            label: prov.title,
            value: prov.id,
          });
        }
      });
      setCities(array);
    } catch ({ err, response }) {
      setGetCitiesLoading(false);
    }
  };

  const getDevices = async () => {
    let array = [];
    try {
      setGetDevicesLoading(true);
      const response = await HttpService.get(`/system-helper/devices?active=1`);
      setGetDevicesLoading(false);
      response.data.data.map((item) => {
        array.push({
          label: item.name,
          value: item.id,
        });
      });
      setDevices(array);
    } catch ({ err, response }) {
      setGetDevicesLoading(false);
    }
  };

  const handleSubmitForm = async (is_submit, confirmMobile) => {
    let postData = {
      mobile: "",
      brand_id: "",
      province_id: "",
      city: "",
      location_id: "",
      device_id: "",
      model: "",
      warranty_id: "",
      service_type_id: "",
      full_name: "",
      form_tab_name: "",
      order_form_token: "",
      order_token: "",
      submission_desc: "",
      address: "",
      plaque: "",
      area_name: "",
      lat: "",
      lng: "",
      apartment_unit_number: "",
      percentage_of_progress: "",
      discount_code: "",
      symptom_id: [],
      device_feature_id: [],
      utm_campaign: "",
      keyword: "",
      utm_adgroup: "",
      gclid: "",
      kwd_id: "",
    };
    if (formData.device_id) {
      postData.device_id = formData.device_id.toString();
    }
    if (formData.province_id) {
      postData.province_id = formData.province_id.toString();
      postData.location_id = formData.province_id.toString();
    }
    if (formData.city) {
      postData.city = formData.city.toString();
    }
    if (formData.mobile.length === 11) {
      postData.mobile = FormatHelper.toEnglishString(formData.mobile);
    }
    if (formData.order_token.length > 0) {
      postData.order_token = formData.order_token;
    }
    if (formData.utm_campaign.length > 0) {
      postData.utm_campaign = formData.utm_campaign;
    }
    if (formData.keyword.length > 0) {
      postData.keyword = formData.keyword;
    }
    if (formData.utm_adgroup.length > 0) {
      postData.utm_adgroup = formData.utm_adgroup;
    }
    if (formData.gclid.length > 0) {
      postData.gclid = formData.gclid;
    }
    if (formData.kwd_id.length > 0) {
      postData.kwd_id = formData.kwd_id;
    }
    try {
      if (is_submit) {
        setSubmitLoading(true);
      }
      const response = await HttpService.post("/order/handler", postData);
      if (is_submit) {
        setSubmitLoading(false);
      }
      if (
        formData.order_token.length === 0 &&
        response?.data?.data?.data?.order_token?.length > 0
      ) {
        setFormData({
          ...formData,
          order_token: response.data.data.data.order_token,
        });
      }
      if (is_submit) {
        if (response?.data?.data?.is_filter === true) {
          window.location.replace(response.data.data.redirect_url);
        } else {
          confirmMobile();
        }
      }
    } catch ({ err, response }) {
      if (is_submit) {
        setSubmitLoading(false);
      }
    }
  };

  const verifyMobile = async (code) => {
    try {
      setVerifyMobileLoading(true);
      const response = await HttpService.post("/order/confirm-order-mobile", {
        order_token: formData.order_token,
        mobile: FormatHelper.toEnglishString(formData.mobile),
        sms_token: FormatHelper.toEnglishString(code),
      });
      setVerifyMobileLoading(false);
      if (response.data.statusCode === 422) {
        message.error(response?.data?.message);
      } else if (response.data.statusCode === 200) {
        window.location.href = response.data.redirect_url;
      }
    } catch (err) {
      setVerifyMobileLoading(false);
    }
  };

  const exports = {
    // get entity methods
    getProvinces,
    getCities,
    getDevices,
    // controller methods
    handleSubmitForm,
    verifyMobile,
    // entity data states
    provinces,
    cities,
    devices,
    formData,
    setFormData,
    // controller states
    submitModal,
    setSubmitModal,
    now,
    setNow,
    showReset,
    setShowReset,
    getProvincesLoading,
    getCitiesLoading,
    getDevicesLoading,
    submitLoading,
    confirmMobileLoading,
    setConfirmMobileLoading,
    verifyMobileLoading,
    setVerifyMobileLoading,
    query,
    setQuery,
  };
  return exports;
};

export default useOrder;
